import { createServerFn } from "@tanstack/react-start";

import { captureException } from "@/observability/sentry";
import { contentSource } from "@/content/source";
import type { HomePageCms } from "@/content/types";

const NOTHING: HomePageCms = { heroVideo: null };

/**
 * What the home page reads from the CMS, at prerender. The video is decoration
 * on a page whose copy is committed, so a CMS that does not answer costs the
 * video and nothing else: the page still builds, and the failure is reported.
 */
export const homeCms = createServerFn({ method: "GET" }).handler(
  async (): Promise<HomePageCms> => {
    try {
      return await (await contentSource()).loadHomePage();
    } catch (error) {
      captureException(error);
      return NOTHING;
    }
  }
);
